export const resortCodes = {
  NV: 'NV',
  USH: 'USH',
  USJ: 'USJ',
};
